import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { FantasyHistoryModule } from '../../../../modules/support/manage-user/gameplay-history/fantasy';
export const Route = createFileRoute(
  '/dashboard/support/manage-user/fantasy-history'
)({
  validateSearch: z.object({
    userId: z.string().optional(),
    fixtureId: z.number().optional(),
    page: z.number().optional(),
    limit: z.number().optional(),
    transactionType: z.enum(['CREDIT', 'DEBIT', 'REFUND']).optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <FantasyHistoryModule />;
}
